module.exports = __webpack_public_path__ + "static/media/sign-up-block-image.e82157ab.png";